import React from 'react';
import { AdminRouteName } from '../CONSTANTS';
import RepaymentTableRecords from './RepaymentTableRecords';

const AllRepayments = () => (
  <RepaymentTableRecords defaultUrl={AdminRouteName.repaymentsRoute} toggleStorageId="all_repayment-table-col" hasNameAndImage permissionName="can-get-repayments" />
);
export default AllRepayments;
